const nav = {
	hamburger: () => {
		let hamburger = document.querySelector('.nav-toggle');
		if (!hamburger)
			return;

		let container = document.querySelector('body');
		hamburger.addEventListener('click', () => {
			hamburger.querySelector('.hamburger-menu').classList.toggle('animate')
			container.classList.toggle('nav--toggled')
		})
	},

	mobileNav() {
		let els = document.querySelectorAll('.menu-item-has-children');
		for (let i = 0; i < els.length; i++) {
			const element = els[i];
			element.addEventListener('click', function () {
				element.querySelector('.submenu-mobile').classList.toggle('hidden');
			})
		}
	}
}

export default nav;